/* globals console, module, require */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const Backbone = require('backbone'),
    jQuery = require('jquery'),
    _ = require('lodash'),
    //
    configuration = require('../utilities/configuration'),
    enumerations = require('../utilities/enumerations'),
    formProcessor = require('../utilities/formProcessor').processor,
    helpers = require('../utilities/handlebars').helpers,
    user = require('../models/user');

module.exports = Backbone.Model.extend({
    parse: function (results, options) {
        const r = _.isArray(results) ? results[0] : results;
        if (r) {
            r.availableDateFormatted = r.availableDate.substr(0, 10);
            r.vacancyStatus = helpers.enumL10n({property: 'vacancyStatusTypeId', id: r.vacancyStatusTypeId});
            // @acavan! - do we need vacancyFillReason string any more?
            // a closed, filled vacancy no longer gets returned by the vacancies endpoint
            // and, even if it did, now we only show in the context of dropdown
            if (r.vacancyStatusTypeId === enumerations.codeValues.vacancyStatusTypeClosedFilled) {
                r.vacancyFillReason = helpers.enumL10n({property: 'vacancyFillReasonTypeId', id: r.vacancyFillReasonTypeId});
            } else { // this shouldn't be necessary but during the early days create included and errant vacancyFillReasonTypeId value
                r.vacancyFillReasonTypeId = null;
                r.vacancyFillReason = '';
            }
        }
        return r;
    },
    sync: function (method, model, options) {
        const url = configuration.apiUrlBase + 'vacancy/',
            ajax = function (ajaxOptions) {
                jQuery.ajax(_.extend({
                    contentType: 'application/json',
                    dataType: 'json',
                    error: options.error,
                    headers: user.authorizationHeader('unit'),
                    success: options.success
                }, ajaxOptions));
            },
            methods = {
                create: function () {
                    ajax({
                        data: JSON.stringify(model.toJSON()),
                        method: 'POST',
                        url: url
                    });
                },
                delete: function () {
                    ajax({
                        method: 'DELETE',
                        url: url + model.id
                    });
                },
                update: function () {
                    ajax({
                        data: JSON.stringify(model.changed),
                        method: 'PUT',
                        url: url + model.id
                    });
                }
            };
        if (methods[method]) {
            methods[method](options);
        } else {
            Backbone.sync.apply(this, arguments);
        }
    },
    update: function (serializedForm) {
        const processedForm = formProcessor(serializedForm);
        this.set(processedForm);
        this.save();
    }
});
